import React, { createContext, useContext, useState } from "react";

export const ARRContext = createContext(null);

export const ARRProvider = ({ children }) => {
  const [arrLevel, setArrLevel] = useState("");

  return (
    <ARRContext.Provider value={{ arrLevel, setArrLevel }}>
      {children}
    </ARRContext.Provider>
  );
};

export const useARRCode = () => useContext(ARRContext);
